<script setup>
import BacklinkTable from '@frontJs/components/tables/projectManagement/seo/BacklinkTable.vue';
import TenantReportBacklinkTable from '@frontJs/components/tables/projectManagement/seo/tenantReports/BacklinkTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, websiteVariants, seoBacklinkPlatforms } = defineProps({
    tenant: {
        type: [Object, null],
        required: false,
        default: null,
    },
    websiteVariants: {
        type: Array,
        required: false,
    },
    seoBacklinkPlatforms: {
        type: Array,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Netlinking - SEO/GEO - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEO/GEO - Netlinking
    </PageTitle>

    <BacklinkTable
        v-if="tenant"
        :tenant="tenant"
        :website-variants="websiteVariants"
        :seo-backlink-platforms="seoBacklinkPlatforms"
    />

    <TenantReportBacklinkTable v-else />
</template>
